import React from "react";
import { FaBell, FaCamera, FaComments, FaLocationDot, FaPaw, FaUserCheck } from "react-icons/fa6";
import "./AppWorkflows.css";

const workflows = [
  {
    icon: <FaLocationDot />,
    title: "Discover nearby cases",
    text: "See rescue, missing, adoption, and stray-care activity around your area.",
  },
  {
    icon: <FaCamera />,
    title: "Post with better context",
    text: "Add photos, location, descriptions, audio, and updates so helpers can respond with clarity.",
  },
  {
    icon: <FaComments />,
    title: "Coordinate in chats",
    text: "Use rescue groups and direct conversations to keep volunteers, NGOs, and responders aligned.",
  },
  {
    icon: <FaBell />,
    title: "Follow every update",
    text: "Follow posts, track status changes, and return to the cases you care about from your profile.",
  },
];

const safetyItems = [
  {
    icon: <FaUserCheck />,
    title: "Try before signing in",
    text: "Guest access lets new users explore the community before creating an account.",
  },
  {
    icon: <FaPaw />,
    title: "Manage your activity",
    text: "Profile tools organize your rescue, adoption, missing, and followed posts in one place.",
  },
];

const AppWorkflows = () => {
  return (
    <section id="features" className="workflow-section">
      <div className="workflow-container">
        <div className="workflow-heading">
          <p>What the app helps you do</p>
          <h2>From a first alert to ongoing care</h2>
        </div>

        <div className="workflow-grid">
          {workflows.map((item) => (
            <article className="workflow-card" key={item.title}>
              <span className="workflow-icon">{item.icon}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>

        <div className="workflow-strip">
          {safetyItems.map((item) => (
            <article className="workflow-strip-item" key={item.title}>
              <span>{item.icon}</span>
              <div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AppWorkflows;
